// // src/pages/AddBranchStaffPage.jsx
// import React, { useState, useEffect, useCallback } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import CustomSelect from "../components/common/CustomSelect";
// import { branchApi, staffApi, api } from "../Apis/Api";
// import useDebounce from "../hook/useDebounce";
// import Breadcrumb from "../components/Breadcrumb";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";

// const AddBranchStaffPage = () => {
//   const [branches, setBranches] = useState([]);
//   const [locations, setLocations] = useState([]);
//   const [staff, setStaff] = useState([]);
//   const [formData, setFormData] = useState({
//     branch_ids: [],
//     location_ids: [],
//     staff_ids: [],
//   });
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [loadingBranches, setLoadingBranches] = useState(false);
//   const [loadingLocations, setLoadingLocations] = useState(false);
//   const [loadingStaff, setLoadingStaff] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   // Pagination states
//   const [staffPage, setStaffPage] = useState(1);
//   const [branchesPage, setBranchesPage] = useState(1);
//   const [locationsPage, setLocationsPage] = useState(1);
//   const [staffTotalPages, setStaffTotalPages] = useState(1);
//   const [branchesTotalPages, setBranchesTotalPages] = useState(1);
//   const [locationsTotalPages, setLocationsTotalPages] = useState(1);
//   const [staffSearch, setStaffSearch] = useState("");
//   const [branchesSearch, setBranchesSearch] = useState("");
//   const [locationsSearch, setLocationsSearch] = useState("");

//   const debouncedStaffSearch = useDebounce(staffSearch, 500);
//   const debouncedBranchesSearch = useDebounce(branchesSearch, 500);
//   const debouncedLocationsSearch = useDebounce(locationsSearch, 500);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const prefilledData = location.state?.stateData || {};
//   const { navigationLink } = location.state || false;

//   const perPage = 10;

//   // Fetch Branches
//   const fetchBranches = useCallback(async (page = 1, search = "") => {
//     setLoadingBranches(true);
//     try {
//       const branchesResponse = await branchApi.getClientBranches({
//         want_pagination: 0,
//         sort_order: "asc",
//         sort_by: "branch_name",
//       });
//       if (!branchesResponse.success || !Array.isArray(branchesResponse.data)) {
//         handleCustomResponse("error", "Failed to load branches!");
//         setBranches([]);
//         setBranchesTotalPages(1);
//         return;
//       }
//       setBranches((prev) =>
//         page === 1 ? branchesResponse.data : [...prev, ...branchesResponse.data]
//       );
//       setBranchesTotalPages(branchesResponse.pagination?.last_page || 1);
//       handleApiResponse(branchesResponse, "fetched branches!", "GET");
//     } catch (err) {
//       handleApiResponse(err, "Failed to load branches.", "GET");
//       setBranches([]);
//       setBranchesTotalPages(1);
//     } finally {
//       setLoadingBranches(false);
//     }
//   }, []);

//   // Fetch Locations (branch_ids ke basis pe)
//   const fetchLocations = useCallback(
//     async (page = 1, search = "") => {
//       if (formData.branch_ids.length === 0) {
//         setLocations([]);
//         setLocationsTotalPages(1);
//         return;
//       }
//       setLoadingLocations(true);
//       try {
//         const locationsResponse = await branchApi.getAllBranchLocations({
//           branch_ids: formData.branch_ids,
//           want_pagination: true,
//           sort_order: "asc",
//           sort_by: "location_name",
//         });
//         if (
//           !locationsResponse.success ||
//           !Array.isArray(locationsResponse.data)
//         ) {
//           handleCustomResponse("error", "Failed to load locations!");
//           setLocations([]);
//           setLocationsTotalPages(1);
//           return;
//         }
//         setLocations((prev) =>
//           page === 1
//             ? locationsResponse.data
//             : [...prev, ...locationsResponse.data]
//         );
//         setLocationsTotalPages(locationsResponse.pagination?.last_page || 1);
//         handleApiResponse(locationsResponse, "fetched locations!", "GET");
//       } catch (err) {
//         handleApiResponse(err, "Failed to load locations.", "GET");
//         setLocations([]);
//         setLocationsTotalPages(1);
//       } finally {
//         setLoadingLocations(false);
//       }
//     },
//     [formData.branch_ids]
//   );

//   // Fetch Staff
//   const fetchStaff = useCallback(async (page = 1, search = "") => {
//     setLoadingStaff(true);
//     try {
//       const staffResponse = await staffApi.getStaffByClient({
//         want_pagination: true,
//         sort_by: "staff_name",
//         sort_order: "asc",
//       });
//       if (!staffResponse.success || !Array.isArray(staffResponse.data)) {
//         handleCustomResponse("error", "Failed to load staff!");
//         setStaff([]);
//         setStaffTotalPages(1);
//         return;
//       }
//       setStaff((prev) =>
//         page === 1 ? staffResponse.data : [...prev, ...staffResponse.data]
//       );
//       setStaffTotalPages(staffResponse.pagination?.last_page || 1);
//       handleApiResponse(staffResponse, "fetched staff!", "GET");
//     } catch (err) {
//       handleApiResponse(err, "Failed to load staff.", "GET");
//       setStaff([]);
//       setStaffTotalPages(1);
//     } finally {
//       setLoadingStaff(false);
//     }
//   }, []);

//   // Pre-fill form data if state has data
//   useEffect(() => {
//     const newFormData = {
//       branch_ids: prefilledData.branch_id
//         ? [prefilledData.branch_id.toString()]
//         : [],
//       location_ids: prefilledData.location_id
//         ? [prefilledData.location_id.toString()]
//         : [],
//       staff_ids: prefilledData.staff_id
//         ? [prefilledData.staff_id.toString()]
//         : [],
//     };
//     setFormData(newFormData);
//   }, [prefilledData]);

//   // Fetch branches on mount and search change
//   useEffect(() => {
//     fetchBranches(1, debouncedBranchesSearch);
//   }, [debouncedBranchesSearch, fetchBranches]);

//   // Fetch locations when branch_ids change or search changes
//   useEffect(() => {
//     fetchLocations(1, debouncedLocationsSearch);
//   }, [debouncedLocationsSearch, fetchLocations]);

//   // Fetch staff on search change
//   useEffect(() => {
//     fetchStaff(1, debouncedStaffSearch);
//   }, [debouncedStaffSearch, fetchStaff]);

//   // Fetch more data on page change
//   useEffect(() => {
//     if (branchesPage > 1) fetchBranches(branchesPage, debouncedBranchesSearch);
//   }, [branchesPage, debouncedBranchesSearch, fetchBranches]);

//   useEffect(() => {
//     if (locationsPage > 1)
//       fetchLocations(locationsPage, debouncedLocationsSearch);
//   }, [locationsPage, debouncedLocationsSearch, fetchLocations]);

//   useEffect(() => {
//     if (staffPage > 1) fetchStaff(staffPage, debouncedStaffSearch);
//   }, [staffPage, debouncedStaffSearch, fetchStaff]);

//   // Handle Branch Selection
//   const handleBranchChange = (selectedOptions) => {
//     const selectedBranchIds = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setFormData((prev) => ({
//       ...prev,
//       branch_ids: selectedBranchIds,
//       location_ids: [], // Reset locations on branch change
//       staff_ids: prefilledData.staff_id
//         ? [prefilledData.staff_id.toString()]
//         : [], // Preserve staff_id if prefilled
//     }));
//     setError(null);
//     setSuccess(null);
//   };

//   // Handle Location Selection
//   const handleLocationChange = (selectedOptions) => {
//     const selectedLocationIds = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setFormData((prev) => ({
//       ...prev,
//       location_ids: selectedLocationIds,
//       staff_ids: prefilledData.staff_id
//         ? [prefilledData.staff_id.toString()]
//         : [], // Preserve staff_id if prefilled
//     }));
//     setError(null);
//     setSuccess(null);
//   };

//   // Handle Staff Selection
//   const handleStaffChange = (selectedOptions) => {
//     const selectedStaffIds = selectedOptions
//       ? selectedOptions.map((option) => option.value)
//       : [];
//     setFormData((prev) => ({
//       ...prev,
//       staff_ids: selectedStaffIds,
//     }));
//     setError(null);
//     setSuccess(null);
//   };

//   // Handle Search Inputs
//   const handleBranchSearch = (inputValue) => {
//     setBranchesSearch(inputValue);
//     setBranchesPage(1);
//   };

//   const handleLocationSearch = (inputValue) => {
//     setLocationsSearch(inputValue);
//     setLocationsPage(1);
//   };

//   const handleStaffSearch = (inputValue) => {
//     setStaffSearch(inputValue);
//     setStaffPage(1);
//   };

//   // Handle Scroll for Pagination
//   const handleBranchesScroll = () => {
//     if (branchesPage < branchesTotalPages && !loadingBranches) {
//       setBranchesPage((prev) => prev + 1);
//     }
//   };

//   const handleLocationsScroll = () => {
//     if (locationsPage < locationsTotalPages && !loadingLocations) {
//       setLocationsPage((prev) => prev + 1);
//     }
//   };

//   const handleStaffScroll = () => {
//     if (staffPage < staffTotalPages && !loadingStaff) {
//       setStaffPage((prev) => prev + 1);
//     }
//   };

//   // Handle Form Submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (
//       formData.branch_ids.length === 0 ||
//       formData.location_ids.length === 0 ||
//       formData.staff_ids.length === 0
//     ) {
//       setError("Please select branch, location, and staff.");
//       handleCustomResponse(
//         "warn",
//         "Please select branch, location, and staff!"
//       );
//       return;
//     }
//     setSubmitting(true);
//     try {
//       const branchLocationMap = {};
//       formData.location_ids.forEach((location_id) => {
//         const location = locations.find(
//           (l) => l.location_id.toString() === location_id
//         );
//         if (
//           location &&
//           formData.branch_ids.includes(location.branch_id.toString())
//         ) {
//           if (!branchLocationMap[location.branch_id]) {
//             branchLocationMap[location.branch_id] = [];
//           }
//           branchLocationMap[location.branch_id].push(parseInt(location_id));
//         }
//       });

//       if (Object.keys(branchLocationMap).length === 0) {
//         setError("No valid branch-location mapping found.");
//         handleCustomResponse(
//           "error",
//           "No valid branch-location mapping found!"
//         );
//         setSubmitting(false);
//         return;
//       }

//       const payload = {
//         staff_ids: formData.staff_ids.map((id) => parseInt(id)),
//         branch_locations: Object.entries(branchLocationMap).map(
//           ([branch_id, location_ids]) => ({
//             branch_id: parseInt(branch_id),
//             location_ids,
//           })
//         ),
//       };

//       const response = await api.post("/assign-staff-locations", payload);
//       if (response.data.success) {
//         handleApiResponse(
//           response.data,
//           "Staff assigned to locations successfully!",
//           "POST"
//         );
//         setSuccess("Staff assigned to locations successfully!");
//         setFormData({ branch_ids: [], location_ids: [], staff_ids: [] });

//         // Check if navigationLink exists and has a valid link
//         if (navigationLink && navigationLink.link) {
//           navigate(`/${navigationLink.link}`);
//         } else {
//           navigate(-1); // Fallback to previous page
//         }
//       } else {
//         setError(response.data.message || "Failed to assign staff.");
//         handleCustomResponse("error", "Failed to assign staff!");
//       }
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || "Failed to assign staff.";
//       setError(errorMsg);
//       const error = err.response?.data || err.message;
//       handleApiResponse(error, "Failed to assign staff!", "POST");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Options for Dropdowns
//   const getBranchOptions = () => {
//     return branches.map((branch) => ({
//       value: branch.branch_id.toString(),
//       label: branch.branch_name,
//     }));
//   };

//   const getFilteredLocationOptions = () => {
//     if (formData.branch_ids.length === 0) return [];
//     const filteredLocations = locations.filter((location) =>
//       formData.branch_ids.includes(location.branch_id.toString())
//     );
//     return filteredLocations.map((location) => ({
//       value: location.location_id.toString(),
//       label: `${location.location_name} (${
//         branches.find(
//           (b) => b.branch_id.toString() === location.branch_id.toString()
//         )?.branch_name || "Unknown Branch"
//       })`,
//     }));
//   };

//   const getStaffOptions = () => {
//     return staff.map((member) => ({
//       value: member.staff_id.toString(),
//       label: member.staff_name,
//     }));
//   };

//   const branchOptions = getBranchOptions();
//   const locationOptions = getFilteredLocationOptions();
//   const staffOptions = getStaffOptions();

//   return (
//     <>
//       <Breadcrumb title="Assign Staff to Branch & Location" />
//       <div className="card h-100 p-0 radius-12">
//         <div className="card-body p-24">
//           {/* {error && <div className="alert alert-danger">{error}</div>}
//           {success && <div className="alert alert-success">{success}</div>} */}
//           <form onSubmit={handleSubmit}>
//             <div className="row g-20">
//               {/* Branch Multi-Select Dropdown */}
//               <div className="col-md-4 mb-20">
//                 <label className="form-label fw-semibold text-primary-light text-sm mb-8">
//                   Branches <span className="text-danger-600">*</span>
//                 </label>
//                 <CustomSelect
//                   name="branch_ids"
//                   isMulti
//                   value={branchOptions.filter((option) =>
//                     formData.branch_ids.includes(option.value)
//                   )}
//                   onChange={handleBranchChange}
//                   onInputChange={handleBranchSearch}
//                   onMenuScrollToBottom={handleBranchesScroll}
//                   options={branchOptions}
//                   placeholder="Search Branches..."
//                   isDisabled={loadingBranches || submitting}
//                   isLoading={loadingBranches}
//                   noOptionsMessage={() => (
//                     <div>
//                       <p>No branches available</p>
//                     </div>
//                   )}
//                   addNewLabel="Create New Branch"
//                   addNewRoute="/branch-create"
//                 />
//               </div>

//               {/* Location Multi-Select Dropdown */}
//               <div className="col-md-4 mb-20">
//                 <label className="form-label fw-semibold text-primary-light text-sm mb-8">
//                   Locations <span className="text-danger-600">*</span>
//                 </label>
//                 <CustomSelect
//                   name="location_ids"
//                   isMulti
//                   value={locationOptions.filter((option) =>
//                     formData.location_ids.includes(option.value)
//                   )}
//                   onChange={handleLocationChange}
//                   onInputChange={handleLocationSearch}
//                   onMenuScrollToBottom={handleLocationsScroll}
//                   options={locationOptions}
//                   placeholder={
//                     formData.branch_ids.length === 0
//                       ? "Select branches first"
//                       : locationOptions.length === 0
//                       ? "No locations available for selected branches"
//                       : "Search Locations..."
//                   }
//                   isDisabled={
//                     formData.branch_ids.length === 0 ||
//                     loadingLocations ||
//                     submitting
//                   }
//                   isLoading={loadingLocations}
//                   noOptionsMessage={() => (
//                     <div>
//                       <p>No locations available</p>
//                     </div>
//                   )}
//                   addNewLabel="Create New Location"
//                   addNewRoute="/branch-location-create"
//                 />
//                 {formData.branch_ids.length === 0 && (
//                   <small className="text-neutral-900 mt-1 d-block">
//                     Please select branches first
//                   </small>
//                 )}
//               </div>

//               {/* Staff Multi-Select Dropdown */}
//               <div className="col-md-4 mb-20">
//                 <label
//                   htmlFor="staff_ids"
//                   className="form-label fw-semibold text-primary-light text-sm mb-8"
//                 >
//                   Staff <span className="text-danger-600">*</span>
//                 </label>
//                 <CustomSelect
//                   name="staff_ids"
//                   isMulti
//                   value={staffOptions.filter((option) =>
//                     formData.staff_ids.includes(option.value)
//                   )}
//                   onChange={handleStaffChange}
//                   onInputChange={handleStaffSearch}
//                   onMenuScrollToBottom={handleStaffScroll}
//                   options={staffOptions}
//                   placeholder="Search Staff..."
//                   isClearable
//                   isLoading={loadingStaff}
//                   isDisabled={formData.location_ids.length === 0 || submitting}
//                   noOptionsMessage={() => (
//                     <div>
//                       <p>No staff available</p>
//                     </div>
//                   )}
//                   addNewLabel="Create New Staff"
//                   addNewRoute="/staff-create"
//                 />
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
//               <button
//                 type="submit"
//                 className="btn btn-primary-600 border border-primary-600 text-md px-56 py-12 radius-8"
//                 disabled={
//                   loadingBranches ||
//                   loadingLocations ||
//                   loadingStaff ||
//                   submitting
//                 }
//               >
//                 {submitting ? "Please Wait..." : "Assign Branch & Location"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddBranchStaffPage;

// src/pages/AddBranchStaffPage.jsx
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CustomSelect from "../components/common/CustomSelect";
import { branchApi, staffApi, api } from "../Apis/Api";
import useDebounce from "../hook/useDebounce";
import Breadcrumb from "../components/Breadcrumb";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import { CancelButtonForm } from "../components/ui/Button";

const AddBranchStaffPage = () => {
  const [branches, setBranches] = useState([]);
  const [locations, setLocations] = useState([]);
  const [staff, setStaff] = useState([]);
  const [formData, setFormData] = useState({
    branch_ids: [],
    location_ids: [],
    staff_ids: [],
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [loadingLocations, setLoadingLocations] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Pagination states
  const [staffPage, setStaffPage] = useState(1);
  const [branchesPage, setBranchesPage] = useState(1);
  const [locationsPage, setLocationsPage] = useState(1);
  const [staffTotalPages, setStaffTotalPages] = useState(1);
  const [branchesTotalPages, setBranchesTotalPages] = useState(1);
  const [locationsTotalPages, setLocationsTotalPages] = useState(1);
  const [staffSearch, setStaffSearch] = useState("");
  const [branchesSearch, setBranchesSearch] = useState("");
  const [locationsSearch, setLocationsSearch] = useState("");

  const debouncedStaffSearch = useDebounce(staffSearch, 500);
  const debouncedBranchesSearch = useDebounce(branchesSearch, 500);
  const debouncedLocationsSearch = useDebounce(locationsSearch, 500);

  const navigate = useNavigate();
  const location = useLocation();
  const prefilledData = location.state?.stateData || {};
  const { navigationLink } = location.state || {};

  const perPage = 10;

  // Fetch Branches
  const fetchBranches = useCallback(
    async (page = 1, search = "") => {
      setLoadingBranches(true);
      try {
        const branchesResponse = await branchApi.getClientBranches({
          want_pagination: true,
          per_page: perPage,
          page,
          sort_order: "asc",
          sort_by: "branch_name",
          search,
        });
        if (
          !branchesResponse.success ||
          !branchesResponse.data ||
          !Array.isArray(branchesResponse.data)
        ) {
          handleCustomResponse("error", "Failed to load branches!");
          setBranches([]);
          setBranchesTotalPages(1);
          return;
        }
        setBranches((prev) =>
          page === 1
            ? branchesResponse.data
            : [...prev, ...branchesResponse.data]
        );
        setBranchesTotalPages(branchesResponse.pagination?.last_page || 1);
        handleApiResponse(branchesResponse, "Fetched branches!", "GET");
      } catch (err) {
        handleApiResponse(err, "Failed to load branches.", "GET");
        setBranches([]);
        setBranchesTotalPages(1);
      } finally {
        setLoadingBranches(false);
      }
    },
    [perPage]
  );

  // Fetch Locations (branch_ids ke basis pe)
  const fetchLocations = useCallback(
    async (page = 1, search = "") => {
      if (formData.branch_ids.length === 0) {
        setLocations([]);
        setLocationsTotalPages(1);
        return;
      }
      setLoadingLocations(true);
      try {
        const locationsResponse = await branchApi.getAllBranchLocations({
          branch_ids: formData.branch_ids,
          want_pagination: true,
          per_page: perPage,
          page,
          sort_order: "asc",
          sort_by: "location_name",
          search,
        });
        if (
          !locationsResponse.success ||
          !locationsResponse.data ||
          !Array.isArray(locationsResponse.data)
        ) {
          handleCustomResponse("error", "Failed to load locations!");
          setLocations([]);
          setLocationsTotalPages(1);
          return;
        }
        setLocations((prev) =>
          page === 1
            ? locationsResponse.data
            : [...prev, ...locationsResponse.data]
        );
        setLocationsTotalPages(locationsResponse.pagination?.last_page || 1);
        handleApiResponse(locationsResponse, "Fetched locations!", "GET");
      } catch (err) {
        handleApiResponse(err, "Failed to load locations.", "GET");
        setLocations([]);
        setLocationsTotalPages(1);
      } finally {
        setLoadingLocations(false);
      }
    },
    [formData.branch_ids, perPage]
  );

  // Fetch Staff
  const fetchStaff = useCallback(
    async (page = 1, search = "") => {
      setLoadingStaff(true);
      try {
        const staffResponse = await staffApi.getStaffByClient({
          want_pagination: true,
          per_page: perPage,
          page,
          sort_by: "staff_name",
          sort_order: "asc",
          search,
        });
        if (
          !staffResponse.success ||
          !staffResponse.data ||
          !Array.isArray(staffResponse.data)
        ) {
          handleCustomResponse("error", "Failed to load staff!");
          setStaff([]);
          setStaffTotalPages(1);
          return;
        }
        setStaff((prev) =>
          page === 1 ? staffResponse.data : [...prev, ...staffResponse.data]
        );
        setStaffTotalPages(staffResponse.pagination?.last_page || 1);
        handleApiResponse(staffResponse, "Fetched staff!", "GET");
      } catch (err) {
        handleApiResponse(err, "Failed to load staff.", "GET");
        setStaff([]);
        setStaffTotalPages(1);
      } finally {
        setLoadingStaff(false);
      }
    },
    [perPage]
  );

  // Pre-fill form data if state has data
  useEffect(() => {
    const newFormData = {
      branch_ids: prefilledData.branch_id
        ? [prefilledData.branch_id.toString()]
        : [],
      location_ids: prefilledData.location_id
        ? [prefilledData.location_id.toString()]
        : [],
      staff_ids: prefilledData.staff_id
        ? [prefilledData.staff_id.toString()]
        : [],
    };
    setFormData(newFormData);

    // Show info if no prefilled data
    // if (
    //   !prefilledData.branch_id &&
    //   !prefilledData.location_id &&
    //   !prefilledData.staff_id
    // ) {
    //   handleCustomResponse(
    //     "info",
    //     "No prefilled data provided. Please select branches, locations, and staff."
    //   );
    // }
  }, []);

  // Validate prefilled data against fetched data
  useEffect(() => {
    if (prefilledData.branch_id && branches.length > 0) {
      const isValidBranch = branches.some(
        (b) => b.branch_id.toString() === prefilledData.branch_id.toString()
      );
      if (!isValidBranch) {
        setError("Invalid prefilled branch ID.");
        setFormData((prev) => ({ ...prev, branch_ids: [] }));
      }
    }
    // Similarly validate location_id and staff_id if needed
  }, [prefilledData.branch_id, branches]);

  // Fetch branches on mount and search change
  useEffect(() => {
    fetchBranches(1, debouncedBranchesSearch);
  }, [debouncedBranchesSearch, fetchBranches]);

  // Fetch locations when branch_ids change or search changes
  useEffect(() => {
    fetchLocations(1, debouncedLocationsSearch);
  }, [debouncedLocationsSearch, fetchLocations]);

  // Fetch staff on search change
  useEffect(() => {
    fetchStaff(1, debouncedStaffSearch);
  }, [debouncedStaffSearch, fetchStaff]);

  // Fetch more data on page change
  useEffect(() => {
    if (branchesPage > 1) fetchBranches(branchesPage, debouncedBranchesSearch);
  }, [branchesPage, debouncedBranchesSearch, fetchBranches]);

  useEffect(() => {
    if (locationsPage > 1)
      fetchLocations(locationsPage, debouncedLocationsSearch);
  }, [locationsPage, debouncedLocationsSearch, fetchLocations]);

  useEffect(() => {
    if (staffPage > 1) fetchStaff(staffPage, debouncedStaffSearch);
  }, [staffPage, debouncedStaffSearch, fetchStaff]);

  // Handle Branch Selection
  const handleBranchChange = (selectedOptions) => {
    const selectedBranchIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prev) => ({
      ...prev,
      branch_ids: selectedBranchIds,
      location_ids: [], // Reset locations on branch change
    }));
    setError(null);
    setSuccess(null);
  };

  // Handle Location Selection
  const handleLocationChange = (selectedOptions) => {
    const selectedLocationIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prev) => ({
      ...prev,
      location_ids: selectedLocationIds,
    }));
    setError(null);
    setSuccess(null);
  };

  // Handle Staff Selection
  const handleStaffChange = (selectedOptions) => {
    const selectedStaffIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prev) => ({
      ...prev,
      staff_ids: selectedStaffIds,
    }));
    setError(null);
    setSuccess(null);
  };

  // Handle Search Inputs
  const handleBranchSearch = (inputValue) => {
    setBranchesSearch(inputValue);
    setBranchesPage(1);
  };

  const handleLocationSearch = (inputValue) => {
    setLocationsSearch(inputValue);
    setLocationsPage(1);
  };

  const handleStaffSearch = (inputValue) => {
    setStaffSearch(inputValue);
    setStaffPage(1);
  };

  // Handle Scroll for Pagination
  const handleBranchesScroll = () => {
    if (branchesPage < branchesTotalPages && !loadingBranches) {
      setBranchesPage((prev) => prev + 1);
    }
  };

  const handleLocationsScroll = () => {
    if (locationsPage < locationsTotalPages && !loadingLocations) {
      setLocationsPage((prev) => prev + 1);
    }
  };

  const handleStaffScroll = () => {
    if (staffPage < staffTotalPages && !loadingStaff) {
      setStaffPage((prev) => prev + 1);
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.branch_ids.length === 0 ||
      formData.location_ids.length === 0 ||
      formData.staff_ids.length === 0
    ) {
      setError("Please select branch, location, and staff.");
      handleCustomResponse(
        "warn",
        "Please select branch, location, and staff!"
      );
      return;
    }

    // Additional validation: Ensure selected IDs are valid
    const validBranchIds = formData.branch_ids.filter((id) =>
      branches.some((b) => b.branch_id.toString() === id)
    );
    if (validBranchIds.length !== formData.branch_ids.length) {
      setError("Invalid branch selection.");
      return;
    }
    // Similarly for locations and staff if needed

    setSubmitting(true);
    try {
      const branchLocationMap = {};
      formData.location_ids.forEach((location_id) => {
        const location = locations.find(
          (l) => l.location_id.toString() === location_id
        );
        if (
          location &&
          formData.branch_ids.includes(location.branch_id.toString())
        ) {
          if (!branchLocationMap[location.branch_id]) {
            branchLocationMap[location.branch_id] = [];
          }
          branchLocationMap[location.branch_id].push(parseInt(location_id));
        }
      });

      if (Object.keys(branchLocationMap).length === 0) {
        setError("No valid branch-location mapping found.");
        handleCustomResponse(
          "error",
          "No valid branch-location mapping found!"
        );
        setSubmitting(false);
        return;
      }

      const payload = {
        staff_ids: formData.staff_ids.map((id) => parseInt(id)),
        branch_locations: Object.entries(branchLocationMap).map(
          ([branch_id, location_ids]) => ({
            branch_id: parseInt(branch_id),
            location_ids,
          })
        ),
      };

      const response = await api.post("/assign-staff-locations", payload);
      if (response.data.success) {
        handleApiResponse(
          response.data,
          "Staff assigned to locations successfully!",
          "POST"
        );
        setSuccess("Staff assigned to locations successfully!");
        setFormData({ branch_ids: [], location_ids: [], staff_ids: [] });

        // Improved navigation fallback
        const targetRoute = navigationLink?.link
          ? `/${navigationLink.link}`
          : -1; // Replace with your default route
        navigate(targetRoute);
      } else {
        setError(response.data.message || "Failed to assign staff.");
        handleCustomResponse("error", "Failed to assign staff!");
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to assign staff.";
      setError(errorMsg);
      const error = err.response?.data || err.message;
      handleApiResponse(error, "Failed to assign staff!", "POST");
    } finally {
      setSubmitting(false);
    }
  };

  // Clear Form
  const handleClear = () => {
    setFormData({ branch_ids: [], location_ids: [], staff_ids: [] });
    setError(null);
    setSuccess(null);
  };

  // Options for Dropdowns (Memoized)
  const branchOptions = useMemo(
    () =>
      branches.map((branch) => ({
        value: branch.branch_id.toString(),
        label: branch.branch_name,
      })),
    [branches]
  );

  const locationOptions = useMemo(() => {
    if (formData.branch_ids.length === 0) return [];
    const filteredLocations = locations.filter((location) =>
      formData.branch_ids.includes(location.branch_id.toString())
    );
    return filteredLocations.map((location) => ({
      value: location.location_id.toString(),
      label: `${location.location_name} (${
        branches.find(
          (b) => b.branch_id.toString() === location.branch_id.toString()
        )?.branch_name || "Unknown Branch"
      })`,
    }));
  }, [formData.branch_ids, locations, branches]);

  const staffOptions = useMemo(
    () =>
      staff.map((member) => ({
        value: member.staff_id.toString(),
        label: member.staff_name,
      })),
    [staff]
  );

  return (
    <>
      <Breadcrumb title="Assign Staff to Branch & Location" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={handleSubmit}>
            <div className="row g-20">
              {/* Branch Multi-Select Dropdown */}
              <div className="col-md-4 mb-20">
                <label
                  htmlFor="branch_ids"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Branches <span className="text-danger-600">*</span>
                </label>
                <CustomSelect
                  id="branch_ids"
                  name="branch_ids"
                  isMulti
                  value={branchOptions.filter((option) =>
                    formData.branch_ids.includes(option.value)
                  )}
                  onChange={handleBranchChange}
                  onInputChange={handleBranchSearch}
                  onMenuScrollToBottom={handleBranchesScroll}
                  options={branchOptions}
                  placeholder="Search Branches..."
                  isDisabled={loadingBranches || submitting}
                  isLoading={
                    loadingBranches ||
                    debouncedBranchesSearch !== branchesSearch
                  }
                  noOptionsMessage={() => (
                    <div>
                      <p>No branches available</p>
                    </div>
                  )}
                  addNewLabel="Create New Branch"
                  addNewRoute="/branch-create"
                />
              </div>

              {/* Location Multi-Select Dropdown */}
              <div className="col-md-4 mb-20">
                <label
                  htmlFor="location_ids"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Locations <span className="text-danger-600">*</span>
                </label>
                <CustomSelect
                  id="location_ids"
                  name="location_ids"
                  isMulti
                  value={locationOptions.filter((option) =>
                    formData.location_ids.includes(option.value)
                  )}
                  onChange={handleLocationChange}
                  onInputChange={handleLocationSearch}
                  onMenuScrollToBottom={handleLocationsScroll}
                  options={locationOptions}
                  placeholder={
                    formData.branch_ids.length === 0
                      ? "Select branches first"
                      : locationOptions.length === 0
                      ? "No locations available for selected branches"
                      : "Search Locations..."
                  }
                  isDisabled={
                    formData.branch_ids.length === 0 ||
                    loadingLocations ||
                    submitting
                  }
                  isLoading={
                    loadingLocations ||
                    debouncedLocationsSearch !== locationsSearch
                  }
                  noOptionsMessage={() => (
                    <div>
                      <p>No locations available</p>
                    </div>
                  )}
                  addNewLabel="Create New Location"
                  addNewRoute="/branch-location-create"
                />
                {formData.branch_ids.length === 0 && (
                  <small className="text-neutral-900 mt-1 d-block">
                    Please select branches first
                  </small>
                )}
              </div>

              {/* Staff Multi-Select Dropdown */}
              <div className="col-md-4 mb-20">
                <label
                  htmlFor="staff_ids"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Staff <span className="text-danger-600">*</span>
                </label>
                <CustomSelect
                  id="staff_ids"
                  name="staff_ids"
                  isMulti
                  value={staffOptions.filter((option) =>
                    formData.staff_ids.includes(option.value)
                  )}
                  onChange={handleStaffChange}
                  onInputChange={handleStaffSearch}
                  onMenuScrollToBottom={handleStaffScroll}
                  options={staffOptions}
                  placeholder="Search Staff..."
                  isClearable
                  isLoading={
                    loadingStaff || debouncedStaffSearch !== staffSearch
                  }
                  isDisabled={formData.location_ids.length === 0 || submitting}
                  noOptionsMessage={() => (
                    <div>
                      <p>No staff available</p>
                    </div>
                  )}
                  addNewLabel="Create New Staff"
                  addNewRoute="/staff-create"
                />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
              {/* <button
                type="button"
                className="btn btn-secondary px-56 py-12 radius-8"
                onClick={handleClear}
                disabled={submitting}
              >
                Clear
              </button> */}
              <CancelButtonForm />
              <button
                type="submit"
                className="btn btn-primary-600 border border-primary-600 text-md px-56 py-12 radius-8"
                disabled={
                  loadingBranches ||
                  loadingLocations ||
                  loadingStaff ||
                  submitting
                }
              >
                {submitting ? "Please Wait..." : "Assign Branch & Location"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddBranchStaffPage;
